var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { metresToMiles, toggleHidden } from "../../helpers";
var titleDataAttribute = 'ptcTitle';
var distanceDataAttribute = 'ptcDistance';
var white = 'rgba(255, 255, 255, 1)';
var blue = 'rgba(0, 67, 122, 1)';
var gold = 'rgba(251, 186, 0, 1)';
var PTCFinderHandler = /** @class */ (function () {
    function PTCFinderHandler(props) {
        var _this = this;
        var _a;
        this.wrapper = undefined;
        this.locationFilter = undefined;
        this.geoLocationFilter = undefined;
        this.sortOrderFilter = undefined;
        this.map = undefined;
        this.autoComplete = undefined;
        this.googleMap = undefined;
        this.googleMapMarkers = [];
        this.googleMapDefaultZoom = undefined;
        this.minimumIncludedMapLocations = undefined;
        this.searchFilter = undefined;
        this.list = undefined;
        this.noResults = undefined;
        this.cachedGeolocation = null;
        this.cachedPTCLocations = [];
        this.allItemsCache = [];
        this.geocodeCache = new Map();
        this.wrapper = props.wrapper;
        this.locationFilter = props.locationFilter;
        this.geoLocationFilter = props.geoLocationFilter;
        this.sortOrderFilter = props.sortOrderFilter;
        this.map = props.map;
        this.searchFilter = props.searchFilter;
        this.list = props.list;
        this.googleMapDefaultZoom = props.googleMapDefaultZoom;
        this.minimumIncludedMapLocations = (_a = props.minimumIncludedMapLocations) !== null && _a !== void 0 ? _a : 2;
        this.locationSearchButton = this.wrapper.querySelector('[data-ptc-location-search]');
        this.travelDistanceSelect = this.wrapper.querySelector('#travel-distance');
        if (this.locationSearchButton && this.travelDistanceSelect) {
            this.locationSearchButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleLocationSearch();
            });
        }
        else {
            console.error("Location search button or travel distance select not found.");
        }
        this.init();
    }
    PTCFinderHandler.prototype.initGeoLocationFilter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var geoLocationButton;
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.geoLocationFilter) {
                    console.error("GeoLocation filter button not found in the DOM.");
                    return [2 /*return*/];
                }
                geoLocationButton = this.geoLocationFilter;
                geoLocationButton.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
                    var ptcLocations;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this.cachedGeolocation) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.getPTCLocations(this.cachedGeolocation)];
                            case 1:
                                ptcLocations = _a.sent();
                                return [4 /*yield*/, this.renderMapLocations({ searchLocation: this.cachedGeolocation, ptcLocations: ptcLocations })];
                            case 2:
                                _a.sent();
                                this.sortItemsByDistance();
                                return [2 /*return*/];
                            case 3:
                                if ('geolocation' in navigator) {
                                    navigator.geolocation.getCurrentPosition(function (position) { return __awaiter(_this, void 0, void 0, function () {
                                        var _a, latitude, longitude, ptcLocations;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    _a = position.coords, latitude = _a.latitude, longitude = _a.longitude;
                                                    this.cachedGeolocation = new google.maps.LatLng(latitude, longitude);
                                                    return [4 /*yield*/, this.getPTCLocations(this.cachedGeolocation)];
                                                case 1:
                                                    ptcLocations = _b.sent();
                                                    return [4 /*yield*/, this.renderMapLocations({ searchLocation: this.cachedGeolocation, ptcLocations: ptcLocations })];
                                                case 2:
                                                    _b.sent();
                                                    this.sortItemsByDistance();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }, function () {
                                        //alert("Error retrieving location.");
                                    });
                                }
                                else {
                                    //alert("Geolocation is not supported by your browser.");
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    PTCFinderHandler.prototype.renderItems = function (_a) {
        var _this = this;
        var items = _a.items, shouldRenderIndexing = _a.shouldRenderIndexing;
        this.list.innerHTML = '';
        items.forEach(function (item, index) {
            var indexElement = item.querySelector('[data-ptc-index]');
            var distanceElement = item.querySelector('[data-ptc-distance]');
            var icon = "<svg width=\"42\" height=\"42\" viewBox=\"0 0 42 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t<path d=\"M22 0c3.978 0 7.794 1.549 10.607 4.306C35.42 7.062 37 10.8 37 14.7C37 25.725 22 42 22 42S7 25.725 7 14.7c0-3.899 1.58-7.638 4.393-10.394C14.206 1.549 18.022 0 22 0z\" fill=\"#00437a\"/>\n\t\t\t\t<text fill=\"#ffffff\" x=\"21\" y=\"21\" text-anchor=\"middle\" font-size=\"14px\">".concat(index + 1, "</text>\n\t\t\t</svg>");
            if (indexElement) {
                toggleHidden(indexElement, !shouldRenderIndexing);
                indexElement.innerHTML = shouldRenderIndexing ? icon : '';
            }
            if (distanceElement) {
                if (shouldRenderIndexing) {
                    var distanceInMetres = Number(item.dataset[distanceDataAttribute]);
                    var distanceInMiles = metresToMiles(distanceInMetres);
                    if (!isNaN(distanceInMiles)) {
                        distanceElement.innerHTML = "(".concat(Math.trunc(distanceInMiles).toString(), " miles)");
                    }
                    else {
                        distanceElement.innerHTML = '';
                    }
                }
                else {
                    distanceElement.innerHTML = '';
                }
                toggleHidden(distanceElement, !shouldRenderIndexing);
            }
            _this.list.appendChild(item);
        });
    };
    PTCFinderHandler.prototype.renderMap = function (_a) {
        var zoom = _a.zoom, center = _a.center;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!this.googleMap) {
                    this.googleMap = new google.maps.Map(this.map, {
                        zoom: zoom,
                        center: center,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        mapId: 'ptc-finder',
                    });
                }
                else {
                    this.googleMap.setCenter(center);
                    this.googleMap.setZoom(zoom);
                }
                toggleHidden(this.map, false);
                return [2 /*return*/];
            });
        });
    };
    PTCFinderHandler.prototype.renderMapLocations = function (_a) {
        var searchLocation = _a.searchLocation, ptcLocations = _a.ptcLocations, _b = _a.zoomToSearchLocation, zoomToSearchLocation = _b === void 0 ? false : _b, radiusMeters = _a.radiusMeters;
        return __awaiter(this, void 0, void 0, function () {
            var bounds, sortedPtcLocations, _c, AdvancedMarkerElement, PinElement, pinBackground, locationCountMap;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.destroyMap();
                        if (!ptcLocations.length) {
                            console.log("No PTC locations found.");
                            return [2 /*return*/];
                        }
                        this.clearMarkers();
                        bounds = new google.maps.LatLngBounds();
                        sortedPtcLocations = ptcLocations.sort(function (a, b) { return a.distance - b.distance; });
                        return [4 /*yield*/, this.renderMap({ zoom: this.googleMapDefaultZoom, center: searchLocation })];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, google.maps.importLibrary("marker")];
                    case 2:
                        _c = _d.sent(), AdvancedMarkerElement = _c.AdvancedMarkerElement, PinElement = _c.PinElement;
                        pinBackground = new PinElement({
                            glyphColor: blue,
                            borderColor: blue,
                            background: gold,
                        });
                        this.googleMapMarkers.push(new AdvancedMarkerElement({
                            position: searchLocation,
                            map: this.googleMap,
                            title: "Your Location",
                            content: pinBackground.element
                        }));
                        locationCountMap = new Map();
                        sortedPtcLocations.forEach(function (location, index) {
                            var position = new google.maps.LatLng(location.lat, location.lng);
                            var locationKey = "".concat(location.lat, ",").concat(location.lng);
                            var offset = locationCountMap.get(locationKey) || 0;
                            var offsetPosition = _this.getpositionmarker(position, offset);
                            locationCountMap.set(locationKey, offset + 1);
                            var markerLabel = (index + 1).toString();
                            var pinBackground = new PinElement({
                                glyph: markerLabel,
                                glyphColor: white,
                                borderColor: blue,
                                background: blue,
                            });
                            _this.googleMapMarkers.push(new AdvancedMarkerElement({
                                position: offsetPosition,
                                map: _this.googleMap,
                                title: "Location ".concat(markerLabel),
                                content: pinBackground.element,
                            }));
                            bounds.extend(offsetPosition);
                        });
                        bounds.extend(searchLocation);
                        if (zoomToSearchLocation && radiusMeters) {
                            this.googleMap.setZoom(this.getZoomLevelForRadius(radiusMeters));
                            this.googleMap.setCenter(searchLocation);
                        }
                        else {
                            this.googleMap.fitBounds(bounds);
                        }
                        this.renderLocationList(sortedPtcLocations);
                        return [2 /*return*/];
                }
            });
        });
    };
    PTCFinderHandler.prototype.getpositionmarker = function (position, offset) {
        if (offset === 0)
            return position;
        var radius1 = 0.004 * offset;
        var cor = offset * 45 * (Math.PI / 180);
        var offsetLat = position.lat() + (Math.cos(cor) * radius1);
        var offsetLng = position.lng() + (Math.sin(cor) * radius1);
        return new google.maps.LatLng(offsetLat, offsetLng);
    };
    PTCFinderHandler.prototype.getZoomLevelForRadius = function (radiusMeters) {
        var scale = radiusMeters / 500;
        return Math.floor(15 - Math.log(scale) / Math.LN2);
    };
    PTCFinderHandler.prototype.milesToMeters = function (miles) {
        return miles * 1609.344;
    };
    PTCFinderHandler.prototype.clearMarkers = function () {
        if (this.googleMapMarkers.length) {
            this.googleMapMarkers.forEach(function (marker) { return marker.setMap(null); });
            this.googleMapMarkers = [];
        }
    };
    PTCFinderHandler.prototype.resetSearch = function () {
        this.clearMarkers();
        this.cachedPTCLocations = [];
    };
    PTCFinderHandler.prototype.destroyMap = function () {
        this.clearMarkers();
    };
    PTCFinderHandler.prototype.sortItemsByDistance = function () {
        var _a, _b;
        var items = Array.from((_b = (_a = this.list) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
        var sortedItems = items.sort(function (a, b) {
            var aDistance = Number(a.dataset[distanceDataAttribute]);
            var bDistance = Number(b.dataset[distanceDataAttribute]);
            return aDistance - bDistance;
        });
        this.renderItems({ items: sortedItems, shouldRenderIndexing: true });
    };
    PTCFinderHandler.prototype.initLocationFilter = function () {
        var _this = this;
        //console.log("Initializing location filter...");
        if (!this.locationFilter) {
            return;
        }
        var input = this.locationFilter.querySelector('#locationInput');
        if (!input) {
            //console.error("Input element inside location filter not found.");
            return;
        }
        //console.log("Input element found. Initializing autocomplete...");
        try {
            var bounds = new window.google.maps.LatLngBounds();
            bounds.extend(new window.google.maps.LatLng(49.64828404100335, -10.963513944150023));
            bounds.extend(new window.google.maps.LatLng(59.340361664775195, -0.04310367356441767));
            this.autoComplete = new window.google.maps.places.Autocomplete(input, {
                bounds: bounds,
                strictBounds: false,
            });
            this.autoComplete.setFields(["place_id", "geometry", "name"]);
            this.autoComplete.addListener("place_changed", function () { return __awaiter(_this, void 0, void 0, function () {
                var place, searchLocation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            place = this.autoComplete.getPlace();
                            if (!(place && place.geometry && place.name)) return [3 /*break*/, 2];
                            searchLocation = place.geometry.location;
                            return [4 /*yield*/, this.renderMap({ zoom: this.googleMapDefaultZoom, center: searchLocation })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 2];
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        }
        catch (e) {
            //console.error("Error initializing location filter:", e);
        }
    };
    PTCFinderHandler.prototype.initSortOrderFilter = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var select, handlers;
            var _this = this;
            return __generator(this, function (_b) {
                select = (_a = this.sortOrderFilter) === null || _a === void 0 ? void 0 : _a.querySelector('select');
                if (!select) {
                    //console.warn('Select element not found in sortOrderFilter');
                    return [2 /*return*/];
                }
                handlers = {
                    '1': function () {
                        var sortedItems = _this.cachedPTCLocations.sort(function (a, b) { return a.title.localeCompare(b.title); });
                        _this.renderLocationList(sortedItems);
                    },
                    '2': function () {
                        var sortedItems = _this.cachedPTCLocations.sort(function (a, b) { return b.title.localeCompare(a.title); });
                        _this.renderLocationList(sortedItems);
                    },
                    '3': function () {
                        var sortedItems = _this.cachedPTCLocations.sort(function (a, b) { return a.distance - b.distance; });
                        _this.renderLocationList(sortedItems);
                    },
                    '4': function () {
                        var sortedItems = _this.cachedPTCLocations.sort(function (a, b) { return b.distance - a.distance; });
                        _this.renderLocationList(sortedItems);
                    }
                };
                select.addEventListener('change', function () {
                    var _a;
                    var value = select.value;
                    (_a = handlers[value]) === null || _a === void 0 ? void 0 : _a.call(handlers);
                });
                return [2 /*return*/];
            });
        });
    };
    PTCFinderHandler.prototype.filterItemsBySearchTerm = function (searchTerm) {
        return this.allItemsCache.filter(function (item) {
            var _a;
            var textContent = ((_a = item.dataset[titleDataAttribute]) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) || '';
            return textContent.includes(searchTerm);
        });
    };
    PTCFinderHandler.prototype.getPTCLocations = function (searchLocation) {
        return __awaiter(this, void 0, void 0, function () {
            var items, ptcLocations_1;
            return __generator(this, function (_a) {
                try {
                    items = document.querySelectorAll('[data-ptc-title]');
                    ptcLocations_1 = [];
                    items.forEach(function (item) {
                        var title = item.getAttribute('data-ptc-title') || '';
                        var base = item.getAttribute('data-ptc-base') || 'Unknown Location';
                        var phoneNumber = item.getAttribute('data-ptc-phoneNumber') || 'Unknown Phone Number';
                        var emailAddress = item.getAttribute('data-ptc-emailAddress') || 'Unknown Email Address';
                        var button = item.getAttribute('data-ptc-button') || 'Unknown connection link for the ptc';
                        var latLng = item.getAttribute('data-ptc-lat-lng') || '';
                        if (latLng) {
                            var _a = latLng.split(',').map(Number), lat = _a[0], lng = _a[1];
                            if (!isNaN(lat) && !isNaN(lng)) {
                                var distance = google.maps.geometry.spherical.computeDistanceBetween(searchLocation, new google.maps.LatLng(lat, lng));
                                ptcLocations_1.push({
                                    title: title,
                                    lat: lat,
                                    lng: lng,
                                    distance: distance,
                                    base: base,
                                    phoneNumber: phoneNumber,
                                    emailAddress: emailAddress,
                                    button: button,
                                    location: base
                                });
                            }
                        }
                    });
                    return [2 /*return*/, ptcLocations_1];
                }
                catch (error) {
                    //console.error('Error fetching PTC locations:', error);
                    return [2 /*return*/, []];
                }
                return [2 /*return*/];
            });
        });
    };
    PTCFinderHandler.prototype.handleLocationSearch = function (userInitiated) {
        var _a;
        if (userInitiated === void 0) { userInitiated = true; }
        return __awaiter(this, void 0, void 0, function () {
            var locationInput, location, searchLocation, _b, error_1;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        locationInput = this.wrapper.querySelector('#locationInput');
                        location = locationInput === null || locationInput === void 0 ? void 0 : locationInput.value.trim();
                        this.clearMarkers();
                        this.toggleMapVisibility(false);
                        if (!location) {
                            //console.log('No location provided, resetting to full list.');
                            this.renderItems({ items: this.allItemsCache, shouldRenderIndexing: true });
                            if (userInitiated) {
                                locationInput.style.border = "2px solid red";
                            }
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, , 8]);
                        locationInput.style.border = "";
                        return [4 /*yield*/, this.geocodeLocation(location)];
                    case 2:
                        searchLocation = _d.sent();
                        if (!searchLocation) return [3 /*break*/, 5];
                        _b = this.renderMapLocations;
                        _c = {
                            searchLocation: searchLocation
                        };
                        return [4 /*yield*/, this.getPTCLocations(searchLocation)];
                    case 3: return [4 /*yield*/, _b.apply(this, [(_c.ptcLocations = _d.sent(),
                                _c.zoomToSearchLocation = true,
                                _c.radiusMeters = this.milesToMeters(parseInt(((_a = this.travelDistanceSelect) === null || _a === void 0 ? void 0 : _a.value) || '15', 10)),
                                _c)])];
                    case 4:
                        _d.sent();
                        this.toggleMapVisibility(true);
                        return [3 /*break*/, 6];
                    case 5:
                        this.toggleMapVisibility(false);
                        _d.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _d.sent();
                        this.toggleMapVisibility(false);
                        locationInput.style.border = "2px solid red";
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    PTCFinderHandler.prototype.preventFormSubmitOnEnter = function () {
        var preventSubmit = function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
            }
        };
        if (this.locationFilter) {
            var input = this.locationFilter.querySelector('#locationInput');
            if (input) {
                input.addEventListener('keydown', preventSubmit);
            }
        }
        if (this.searchFilter) {
            var input = this.searchFilter.querySelector('input');
            if (input) {
                input.addEventListener('keydown', preventSubmit);
            }
        }
        document.addEventListener('submit', function (event) {
            event.preventDefault();
            //console.log("Global form submission prevented.");
        });
    };
    PTCFinderHandler.prototype.geocodeLocation = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheExpiryTime, cachedData, geocoder, postcodeRegex;
            var _this = this;
            return __generator(this, function (_a) {
                cacheExpiryTime = 60 * 60 * 1000;
                cachedData = this.geocodeCache.get(location);
                if (cachedData && (Date.now() - cachedData.timestamp < cacheExpiryTime)) {
                    //console.log(`Using cached geocoded location for: "${location}"`);
                    return [2 /*return*/, cachedData.location];
                }
                geocoder = new google.maps.Geocoder();
                postcodeRegex = /^[A-Z0-9]{1,4} ?[0-9][A-Z]{2}$/i;
                return [2 /*return*/, new Promise(function (resolve) {
                        //console.log(`Attempting to geocode location: "${location}"`);
                        var locationInput = _this.wrapper.querySelector('#locationInput');
                        if (postcodeRegex.test(location)) {
                            geocoder.geocode({ address: location }, function (results, status) {
                                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                                    var geoLocation = results[0].geometry.location;
                                    locationInput.style.border = "";
                                    _this.geocodeCache.set(location, { location: geoLocation, timestamp: Date.now() });
                                    resolve(geoLocation);
                                }
                                else {
                                    //console.error(`Geocoding failed for postcode "${location}": ${status}`);
                                    locationInput.style.border = "2px solid red";
                                    resolve(null);
                                }
                            });
                        }
                        else {
                            var locationWithCountry = "".concat(location, ", UK");
                            geocoder.geocode({ address: locationWithCountry }, function (results, status) {
                                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                                    var geoLocation = results[0].geometry.location;
                                    locationInput.style.border = "";
                                    _this.geocodeCache.set(location, { location: geoLocation, timestamp: Date.now() });
                                    resolve(geoLocation);
                                }
                                else {
                                    //console.error(`Geocoding failed for town "${locationWithCountry}": ${status}`);
                                    locationInput.style.border = "2px solid red";
                                    resolve(null);
                                }
                            });
                        }
                    })];
            });
        });
    };
    PTCFinderHandler.prototype.clearCache = function () {
        this.cachedGeolocation = null;
        this.cachedPTCLocations = [];
    };
    PTCFinderHandler.prototype.renderLocationList = function (locations) {
        var listElement = document.querySelector('[data-ptc-list]');
        if (!listElement)
            return;
        listElement.innerHTML = '';
        locations.forEach(function (location) {
            var listItem = document.createElement('li');
            listItem.className = 'flex flex-wrap flex-col gap-8 xl:flex-row justify-between w-full items-start xl:items-end py-8 border-aqua-haze';
            listItem.setAttribute('data-ptc-title', location.title);
            listItem.setAttribute('data-ptc-base', location.base);
            listItem.setAttribute('data-ptc-phoneNumber', location.phoneNumber);
            listItem.setAttribute('data-ptc-emailAddress', location.emailAddress);
            listItem.setAttribute('data-ptc-button', location.button);
            listItem.setAttribute('data-ptc-lat-lng', "".concat(location.lat, ",").concat(location.lng));
            var phoneNumber = location.phoneNumber || 'No phone number available';
            var emailAddress = location.emailAddress || 'No email address available';
            var buttonLink = location.button || '#';
            var distanceInMiles = !isNaN(location.distance) ? metresToMiles(location.distance) : 0;
            var html = "\n\t\t\t<div class=\"mb-6 xl:mb-0\">\n\t\t\t\t<h3 class=\"text-3xl text-midnight mb-2\">".concat(location.title, "</h3>\n\t\t\t\t<div> Location: <strong>").concat(location.base, "</strong></div>\n\t\t\t\t<div> Phone Number: <strong>").concat(phoneNumber, "</strong></div>\n\t\t\t\t<div> Email: <strong>").concat(emailAddress, "</strong></div>\n\t\t\t\t<div>Distance: ").concat(Math.trunc(distanceInMiles), " miles</div>\n\t\t\t</div>\n\t\t\t<a href=\"").concat(buttonLink, "\" class=\"min-w-fit bg-regal-blue text-white px-6 py-3 rounded font-bold\">\n\t\t\t\tVIEW CONSULTANT'S BIO\n\t\t\t</a>\n\t\t\t");
            listItem.innerHTML = html;
            listElement.appendChild(listItem);
        });
    };
    PTCFinderHandler.prototype.debounce = function (fn, delay) {
        var timeoutId;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(timeoutId);
            timeoutId = window.setTimeout(function () { return fn.apply(void 0, args); }, delay);
        };
    };
    PTCFinderHandler.prototype.initSearchFilter = function () {
        var _this = this;
        var _a, _b;
        var input = this.searchFilter.querySelector('input');
        this.allItemsCache = Array.from((_b = (_a = this.list) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
        var handleSearch = function (event) {
            var searchTerm = input.value.trim().toLowerCase();
            event.preventDefault();
            _this.toggleMapVisibility(false);
            if (searchTerm) {
                var filteredItems = _this.filterItemsBySearchTerm(searchTerm);
                _this.renderItems({ items: filteredItems, shouldRenderIndexing: true });
            }
            else {
                //console.log('Empty search term, resetting to full list.');
                _this.renderItems({ items: _this.allItemsCache, shouldRenderIndexing: true });
            }
        };
        input.addEventListener('input', this.debounce(handleSearch, 300));
    };
    PTCFinderHandler.prototype.toggleMapVisibility = function (show) {
        if (this.map) {
            if (show) {
                this.map.removeAttribute('hidden');
            }
            else {
                this.map.setAttribute('hidden', 'hidden');
            }
        }
    };
    PTCFinderHandler.prototype.initLocationSearchListener = function () {
        var _this = this;
        var locationInput = this.wrapper.querySelector('#locationInput');
        var nameInput = this.searchFilter.querySelector('input');
        if (locationInput && nameInput) {
            locationInput.addEventListener('click', function () {
                nameInput.value = '';
                //console.log('Location input clicked. Name input cleared.');
                var searchTerm = nameInput.value.trim().toLowerCase();
                _this.toggleMapVisibility(false);
                if (!searchTerm) {
                    //console.log('Empty search term, resetting to full list.');
                    _this.renderItems({ items: _this.allItemsCache, shouldRenderIndexing: true });
                }
                else {
                    var filteredItems = _this.filterItemsBySearchTerm(searchTerm);
                    _this.renderItems({ items: filteredItems, shouldRenderIndexing: true });
                }
            });
        }
    };
    PTCFinderHandler.prototype.init = function () {
        var _a, _b;
        if (this.geoLocationFilter) {
            this.allItemsCache = Array.from((_b = (_a = this.list) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
            this.initSearchFilter();
            this.initLocationFilter();
            this.initSortOrderFilter();
            this.initGeoLocationFilter();
            this.preventFormSubmitOnEnter();
            this.initLocationSearchListener();
        }
        else {
            //console.error("GeoLocation filter button is not available.");
        }
    };
    return PTCFinderHandler;
}());
export { PTCFinderHandler };
export default PTCFinderHandler;
